import {
  Avatar,
  FieldText,
  FlexBox,
  IconButton,
  Table,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { QueueAgent } from 'lib-shared-legacy-types';
import * as React from 'react';
import { Field, WrappedFieldArrayProps } from 'redux-form';


import styles from '../queues.module.scss';
import { parsePriorityValue } from '../utils';

type QueuesAgentsTableRowOwnProps = {
  items: QueueAgent[];
  queueOfferAlgorithm?: string;
  showRemoveModal: (queueAgent: QueueAgent) => void;
};

type Props = QueuesAgentsTableRowOwnProps & WrappedFieldArrayProps;

export const QueuesAgentsTableRow: React.FunctionComponent<Props> = (props) => {
  const { queueOfferAlgorithm, fields, items, showRemoveModal } = props;

  const handleRemoveClick = (queueAgent: QueueAgent) => {
    showRemoveModal(queueAgent);
  };

  return (
    <React.Fragment>
      {fields.map((agent, index) => {
        if (!items.length) {
          return null;
        }

        return (
          <Table.Tr key={index}>
            <Table.Td>
              <FlexBox alignItems="center">
                <div className={styles.avatarWrap}>
                  <Avatar user={items[index]} />
                </div>

                {items[index].name}
              </FlexBox>
            </Table.Td>
            <Table.Td>{items[index].email}</Table.Td>
            {queueOfferAlgorithm?.includes('agent_priority') && (
              <Table.Td>
                <Field
                  name={`${agent}.priority`}
                  component={FieldText}
                  type="number"
                  className={styles.priorityInput}
                  parse={parsePriorityValue}
                  min="1"
                  noLabel
                  noAlert
                />
              </Table.Td>
            )}
            <Table.Td className={styles.cellActions}>
              <Tooltip content="Remove agent from queue" dark>
                <IconButton
                  variant="tertiary"
                  icon="trash"
                  className={styles.action}
                  onClick={() => handleRemoveClick(items[index])}
                />
              </Tooltip>
            </Table.Td>
          </Table.Tr>
        );
      })}
    </React.Fragment>
  );
};
